import { Box, Card, IconButton, Tab, Tabs, InputAdornment, TextField as MuiTextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import {
  downloadSurveyorResponses,
  getSurveyorDownloadList,
  getSurveyorResponses,
  getSurvyorFilterData,
  surveyDownload,
} from "../../../../services/surveyor/surveyor";
import DataGridSurveyorResponses from "../data_grid/data_grid";
import Loading from "../../../../components/loading/loading";
import FilterSubmittedChoiceList from "../filter_submitted_choice_list/filter_submitted_choice_list";
import { SurveyorFilterModel } from "../../model/surveyor_filter_model";
import FilterIcon from "../../../../assets/filter_icon.svg";
import XlsIcon from "../../../../assets/xls_icon.svg";
import SortIcon from "../../../../assets/sort.svg";
import { downloadFromBlob } from "../../../../utils/utils";
import MainLayout from "../../../../layouts/main/main_layout";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ArrowBackRounded, ChecklistRtlRounded, SearchRounded } from "@mui/icons-material";
import { useFeedback } from "../../../../providers/feedback/feeedback";
import { RECORDS_EXCEEDS_ALERT_MSG } from "../../../../constants";
import { NeedFilters } from "../../../needs/model/needs_filters";
import { getNeedsFilters } from "../../../../services/needs/needs_service";
import { black, greyEnabled, purple, purpleLight } from "../../../../theme/colors";
import styled from "@emotion/styled";
import DataGridDownloads from "../data_grid_downloads/data_grid_downloads";
import FilterForDownloads from "../filter_for_downloads/filter_for_downloads";
import { useSurveyorResponsesFilterStore } from "../../../../store/use-surveyors-responses-filter-store";
import { useActiveFilterCount } from "../../../../store/use-surveyors-responses-filter-store";
import { queryClient } from "../../../../providers/query/query";
import { ToolbarButton } from "../../../../components/toolbar_button/toolbar_button";
import SortSurveysPopup from "../../../choices/components/sort_surveys_popup/sort_surveys_popup";

export interface SurveyorResponseLabel {
  label: string;
}

const ROWS_PER_PAGE_OPTIONS = [8, 25, 50, 100];

const TextField = styled(MuiTextField)(() => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    "& fieldset": { borderColor: "#ABA0AB" },
    "&:hover fieldset": { borderColor: purple },
    "&.Mui-focused fieldset": { borderColor: purple, borderWidth: 2 },
  },
}));

export default function SurveyorChoiceResponseList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { showSnackbar } = useFeedback();
  const { id } = useParams();
  const {
  page, setPage,
  pageForDownloads, setPageForDownloads,
  openModel, setOpenModel,
  openModelForDownloads, setOpenModelForDownloads,
  startDate, setStartDate,
  startDateForDownloads, setStartDateForDownloads,
  endDate, setEndDate,
  endDateForDownloads, setEndDateForDownloads,
  schemeKeyword, setSchemeKeyword,
  stateId, setStateId,
  categoryId, setCategoryId,
  selectedGender, setSelectedGender,
  occupationId, setOccupationId,
  educationId, setEducationId,
  incomeId, setIncomeId,
  sortInAcceding, setSortInAcceding,
  cityId, setCityId,
  searchValue, setSearchValue,
  status, setStatus,
  districtId, setDistrictId,
  currentTab, setCurrentTab,
  resetFilters
} = useSurveyorResponsesFilterStore();

const activeCount=useActiveFilterCount()

  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(ROWS_PER_PAGE_OPTIONS[0]);
  const [pageSizeForDownloads, setPageSizeForDownloads] = useState(ROWS_PER_PAGE_OPTIONS[0]);
  const [sortDialogOpen, setSortDialogOpen] = useState(false);
  const [exporting, setExporting] = useState(false);
  const sortOption = sortInAcceding ? "newest" : "oldest";
  const setSortOption = (option: "newest" | "oldest") => setSortInAcceding(option === "newest");

  const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchValue]);

  const isFirstSearchRender = useRef(true);
  useEffect(() => {
    if (isFirstSearchRender.current) {
      isFirstSearchRender.current = false;
      return;
    }
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchValue]);

  useEffect(() => {
    const currentPage = searchParams.get("page");
    const newPage = (page + 1).toString();
    if (currentPage !== newPage) {
      setSearchParams({ page: newPage }, { replace: true, });
    }
  }, [page, setSearchParams]);

  const handleChange = (event: React.SyntheticEvent, currentTabVal: number) => {
    setCurrentTab(currentTabVal);
  };
  const surveyorResponseLabel: SurveyorResponseLabel[] = [
    {
      label: "UID",
    },
    {
      label: "Full Name",
    },
    {
      label: "Survey Name",
    },
    {
      label: "Contact Number",
    },

    {
      label: "State",
    },
    {
      label: "District",
    },
    {
      label: "Submitted On",
    },
  ];

  const surveyorDownloads: SurveyorResponseLabel[] = [
    {
      label: "SL. No",
    },
    {
      label: "Survey Name",
    },
    {
      label: "Status",
    },
    {
      label: "Remark",
    },

    {
      label: "Processed By",
    },
    {
      label: "Processed At",
    },
    {
      label: "Record Count",
    },
    {
      label: "Action",
    },
  ];

  const { data: surveyorResponseList, isLoading } = useQuery(
    [
      "surveyorResponseList",
      id,
      page,
      pageSize,
      sortInAcceding,
      categoryId,
      startDate,
      endDate,
      educationId,
      selectedGender,
      occupationId,
      incomeId,
      stateId,
      cityId,
      debouncedSearchValue,
      districtId,
    ],
    async () => {
      try {
        let sortOrder = sortInAcceding ? "DESC" : "ASC";
      let response = await getSurveyorResponses({
        page: page + 1,
        size: pageSize,
        category: categoryId,
        dateFrom: startDate,
        dateTo: endDate,
        education: educationId,
        gender: selectedGender,
        occupation: occupationId,
        personalIncome: incomeId,
        state: stateId,
        choiceId: +id!,
        sortOrder: sortOrder,
        city: cityId,
        keyword: debouncedSearchValue,
        districtId: districtId,
      });
      return response.data.data;
      }  catch(error){
        console.log("error",error);
        return { list: [], total: 0 };
      }
    }
    ,{ retry: false }
  );



  const { data: surveyorDownloadList, isLoading: isDownloadListLoading } = useQuery(
    [
      "surveyorDownloadList",
      id,
      pageForDownloads,
      pageSizeForDownloads,
    ],
    async () => {
      try{
      let sortOrder = sortInAcceding ? "DESC" : "ASC";
      let response = await getSurveyorDownloadList({
        page: pageForDownloads + 1,
        size: pageSizeForDownloads,
        category: categoryId,
        dateFrom: startDateForDownloads,
        dateTo: endDateForDownloads,
        education: educationId,
        gender: selectedGender,
        occupation: occupationId,
        personalIncome: incomeId,
        state: stateId,
        choiceId: +id!,
        sortOrder: sortOrder,
        status: status
      });
      return response.data.data?.data;
      }
      catch(error){
        console.log("error",error);
        queryClient.setQueryData(['surveyorDownloadList'],[])
      }
      
    }
    ,{
      // enabled:applyFilter
    }
  );

  function surveyDownloadApiCall(taskId: number) {
    surveyDownload({ taskId: taskId }).then((res) => {
     window.open(res?.data?.data?.downloadUrl)
    }).catch((e) => { })
  }

  function download() {
    let sortOrder = sortInAcceding ? "DESC" : "ASC";

    setExporting(true);
    downloadSurveyorResponses({
      page: 1,
      size: 1000,
      category: categoryId,
      dateFrom: startDate,
      dateTo: endDate,
      education: educationId,
      gender: selectedGender,
      occupation: occupationId,
      personalIncome: incomeId,
      state: stateId,
      choiceId: +id!,
      sortOrder: sortOrder,
      city: cityId,
    })
      .then((res) => {
        console.log(res.data, 'data');
        showSnackbar(res?.data?.data?.message);

      })
      .catch((e) => {
        console.log(e.response, 'res');
        showSnackbar(e?.response?.data?.error?.message);
      })
      .finally(() => setExporting(false));

  }
  const { data: surveyorMasterData } = useQuery<SurveyorFilterModel>(
    ["surveyorFilterData"],
    async () => {
      let response = await getSurvyorFilterData();
      return response.data.data;
    }
  );

  const { data: needsFilters } = useQuery<NeedFilters>(
    ["needs-filters"],
    async () => {
      let data = await getNeedsFilters();
      return data?.data?.data;
    }
  );

  let statusList: { id: number, value: string }[] = [
    {
      id: 1, value: 'Pending'
    },
    {
      id: 2, value: 'Completed'
    },
    {
      id: 3, value: 'Failed'
    }
  ]

  function searchComponent() {
    return (
      <Box maxWidth={{ xs: "100%", sm: 360 }}>
        <TextField
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
          size="small"
          fullWidth
          placeholder="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRounded sx={{ color: "text.primary" }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
    );
  }

  return (
    <MainLayout>
      <Box display="flex" alignItems="center" gap={1} mb={2} mt={2}>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackRounded />
        </IconButton>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              borderRadius: 2,
              bgcolor: purpleLight,
              flexShrink: 0,
            }}
          >
            <ChecklistRtlRounded sx={{ color: purple, fontSize: 22 }} />
          </Box>
          <Box>
            <Typography variant="h5" fontWeight={700} color={black}>
              Surveyor Responses
            </Typography>
            <Typography variant="body2" color={greyEnabled}>
              View submitted responses and manage downloaded reports for this survey.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Card elevation={0} sx={{ display: "flex", flexDirection: "column", width: "100%", minHeight: 600, mb: 2, borderRadius: 3, border: "1px solid #ECECEC" }}>
        <Box sx={{ borderBottom: "1px solid #ECECEC", px: 3, pt: 1 }}>
          <Tabs
            value={currentTab}
            onChange={handleChange}
            TabIndicatorProps={{ style: { backgroundColor: purple, height: 3, borderRadius: 3 } }}
          >
            <Tab
              label="Survey Responses"
              sx={{ textTransform: "none", fontWeight: 600, color: greyEnabled, "&.Mui-selected": { color: purple } }}
            />
            <Tab
              label="Downloads"
              sx={{ textTransform: "none", fontWeight: 600, color: greyEnabled, "&.Mui-selected": { color: purple } }}
            />
          </Tabs>
        </Box>
        {currentTab === 0 &&
          <Box sx={{ p: { xs: 2.5, sm: 3 } }}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
              gap={2}
              mb={2}
            >
              {searchComponent()}
              <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                <ToolbarButton
                  icon={XlsIcon}
                  label="Export"
                  onClick={download}
                  loading={exporting}
                  disabled={exporting}
                />
                <ToolbarButton
                  icon={SortIcon}
                  label={sortInAcceding ? "New to old" : "Old to new"}
                  onClick={() => setSortDialogOpen(true)}
                />
                <ToolbarButton
                  icon={FilterIcon}
                  label="Filters"
                  badgeCount={activeCount}
                  onClick={() => setOpenModel(true)}
                />
              </Box>
            </Box>
            {isLoading ? (
              <Box display="flex" justifyContent="center" py={8}>
                <Loading />
              </Box>
            ) : (
              <DataGridSurveyorResponses
                count={surveyorResponseList?.total || 0}
                data={surveyorResponseList?.list || []}
                labels={surveyorResponseLabel}
                setPage={setPage}
                page={page}
                pageSize={pageSize}
                setPageSize={setPageSize}
              />
            )}
          </Box>
        }
        {currentTab === 1 &&
          <Box sx={{ p: { xs: 2.5, sm: 3 } }}>
            <Box display="flex" justifyContent="flex-end" gap={1.5} flexWrap="wrap" mb={2}>
              <ToolbarButton
                icon={SortIcon}
                label={sortInAcceding ? "New to old" : "Old to new"}
                onClick={() => setSortDialogOpen(true)}
              />
              <ToolbarButton
                icon={FilterIcon}
                label="Filters"
                onClick={() => setOpenModelForDownloads(true)}
              />
            </Box>
            {isDownloadListLoading ? (
              <Box display="flex" justifyContent="center" py={8}>
                <Loading />
              </Box>
            ) : (
              <DataGridDownloads
                count={surveyorDownloadList?.total || 0}
                data={surveyorDownloadList?.list || []}
                labels={surveyorDownloads}
                setPage={setPageForDownloads}
                page={pageForDownloads}
                pageSize={pageSizeForDownloads}
                setPageSize={setPageSizeForDownloads}
                downloadResponse={(id) => {
                  surveyDownloadApiCall(id);
                }}
              />
            )}
          </Box>}
      </Card>

      <SortSurveysPopup
        open={sortDialogOpen}
        onClose={() => setSortDialogOpen(false)}
        sortOption={sortOption}
        setSortOption={setSortOption}
      />

      <FilterSubmittedChoiceList
        // districtId={districtId}
        // setDistrictId={setDistrictId}
        cities={needsFilters?.cityList || []}
        // setCityId={setCityId}
        // cityId={cityId}
        genderList={surveyorMasterData?.gender || []}
        // openModal={openModel}
        // setOpenModal={setOpenModel}
        // startDate={startDate}
        // setStartDate={setStartDate}
        // endDate={endDate}
        // setEndDate={setEndDate}
        // schemeKeyword={schemeKeyword}
        // setSchemeKeyword={setSchemeKeyword}
        states={surveyorMasterData?.state || []}
        occupation={surveyorMasterData?.occupation || []}
        education={surveyorMasterData?.education || []}
        income={surveyorMasterData?.personalIncome || []}
        // occupationId={occupationId}
        // setOccupationId={setOccupationId}
        // educationId={educationId}
        // setEducationId={setEducationId}
        // incomeId={incomeId}
        // setIncomeId={setIncomeId}
        // stateId={stateId}
        // setStateId={setStateId}
        // categoryId={categoryId}
        // setCategoryId={setCategoryId}
        // resetFilter={() => {
        //   setCategoryId(null);
        //   setStateId(null);
        //   setStartDate("");
        //   setEndDate("");
        //   setSelectedGender("");
        //   setOccupationId(null);
        //   setEducationId(null);
        //   setPage(0);
        //   setIncomeId(null);
        //   setCityId(null);
        // }}
        // selectedGender={selectedGender}
        // setSelectedGender={setSelectedGender}
      />
      <FilterForDownloads
        status={status}
        setStatus={setStatus}
        statusList={statusList}
        cities={needsFilters?.cityList || []}
        setCityId={setCityId}
        cityId={cityId}
        genderList={surveyorMasterData?.gender || []}
        openModal={openModelForDownloads}
        setOpenModal={setOpenModelForDownloads}
        startDate={startDateForDownloads}
        setStartDate={setStartDateForDownloads}
        endDate={endDateForDownloads}
        setEndDate={setEndDateForDownloads}
        schemeKeyword={schemeKeyword}
        setSchemeKeyword={setSchemeKeyword}
        states={surveyorMasterData?.state || []}
        occupation={surveyorMasterData?.occupation || []}
        education={surveyorMasterData?.education || []}
        income={surveyorMasterData?.personalIncome || []}
        occupationId={occupationId}
        setOccupationId={setOccupationId}
        educationId={educationId}
        setEducationId={setEducationId}
        incomeId={incomeId}
        setIncomeId={setIncomeId}
        stateId={stateId}
        setStateId={setStateId}
        categoryId={categoryId}
        setCategoryId={setCategoryId}
        resetFilter={() => {
          setCategoryId(null);
          setStateId(null);
          setStartDateForDownloads("");
          setEndDateForDownloads("");
          setSelectedGender("");
          setOccupationId(null);
          setEducationId(null);
          setPageForDownloads(0);
          setIncomeId(null);
          setCityId(null);
          setStatus(null)

        }}
        selectedGender={selectedGender}
        setSelectedGender={setSelectedGender}
      />
    </MainLayout>
  );
}
